import gql from 'graphql-tag'
import * as client from '@dinosband/bv-main-schema/dist/client-gql'

export const findManySettlementItem = gql`
  query findManySettlementItem($where: SettlementItemWhereInput!, $skip: Int, $take: Int, $cursor: SettlementItemWhereUniqueInput, $orderBy: [SettlementItemOrderByWithRelationInput!]) {
    findManySettlementItem(where: $where, skip: $skip, take: $take, cursor: $cursor, orderBy: $orderBy) {
      ...SettlementItemFields
      commerceOrder {
        ...CommerceOrderFields
      }
      commerceProduct {
        ...CommerceProductFields
      }
      jrsp {
        ...JobOfferResponseFields
      }
      jobOffer {
        ...JobOfferFields
      }
    }
  }
  ${client.SettlementItemFields}
  ${client.CommerceOrderFields}
  ${client.CommerceProductFields}
  ${client.JobOfferResponseFields}
  ${client.JobOfferFields}
`
